import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class CommunicationService {

    static getCommsByAmendmentId = (id, callback, errCallback, queryParams) => {
        NetworkService.get(`${API_BASE_URL}/communication/${id}`, callback, errCallback, queryParams);
    };

    static createCommunication = (id, body, callback, errCallback, queryParams) => {
        NetworkService.postMultiPart(`${API_BASE_URL}/communication/${id}`, body, callback, errCallback, queryParams);
    };
}
